<p>ui-client-pages works!</p>
